/**
 * 得意先検索モーダルが閉じた後のフォーカス移動判定フラグ
 * @type {boolean}
 */
let flgChangeFocusSearchCustomer = false;
/**
 * 工事検索モーダルが閉じた後のフォーカス移動判定フラグ
 * @type {boolean}
 */
let flgChangeFocusSearchConstrSite = false;
/**
 * 担当者（社員）検索モーダルが閉じた後のフォーカス移動判定フラグ
 * @type {boolean}
 */
let flgChangeFocusSearchEmployee = false;
/**
 * 部門検索モーダルが閉じた後のフォーカス移動判定フラグ
 * @type {boolean}
 */
let flgChangeFocusSearchDepartment = false;

/**
 * 複製チェックエリアのdisabled付与
 */
window.disabledCopyCheckArea = function () {
    $('.copy_check_area').each(function () {
        if ($(this).find('.copy_check_input').prop('checked')) {
            $(this).find('.copy_input').prop('disabled', true);
        }
    });
};

/**
 * 必須項目が全て入力されているかチェック
 */
window.checkAllRequiredFieldsCopyCheck = function () {
    let ok_button = $('#btn_ok_confirm-copy');
    // 複製確認モーダルのOKボタンをenabled
    ok_button.prop('disabled', false);
    $('.copy_check_area .is-required').each(function () {
        // 複製チェックが入っていたら、return true
        if ($(this).find('.copy_check_input').is(':checked')) {
            return true;
        }
        // 項目が入力されていたら、return true
        if ($(this).find('.copy_input').val() || $(this).find('.copy_input').find('option:selected').val()) {
            return true;
        }
        // 複製確認モーダルのOKボタンをdisabled
        ok_button.prop('disabled', true);
    });
};

/**
 * 即時実行関数
 */
(function () {
    /** 複製チェックエリアのdisabled付与 */
    disabledCopyCheckArea();

    /**
     * 得意先検索ボタンフォーカスインイベント
     */
    $('[data-target="#search-customer-copy-check"]').on('focusin', function () {
        if (flgChangeFocusSearchCustomer) {
            // 得意先リストにフォーカス移動
            $('.input-customer-select').focus();
            // フラグをOFF
            flgChangeFocusSearchCustomer = false;
        }
    });

    /**
     * 工事検索ボタンフォーカスインイベント
     */
    $('[data-target="#search-constr-site-copy-check"]').on('focusin', function () {
        if (flgChangeFocusSearchConstrSite) {
            // 工事リストにフォーカス移動
            $('.input-constr-site-select').focus();
            // フラグをOFF
            flgChangeFocusSearchConstrSite = false;
        }
    });

    /**
     * 担当者（社員）検索ボタンフォーカスインイベント
     */
    $('[data-target="#search-employee-copy-check"]').on('focusin', function () {
        if (flgChangeFocusSearchEmployee) {
            // 対象行の担当者リストにフォーカス移動
            $('.input-employee-select').focus();
            // フラグをOFF
            flgChangeFocusSearchEmployee = false;
        }
    });

    /**
     * 部門検索ボタンフォーカスインイベント
     */
    $('[data-target="#search-department-copy-check"]').on('focusin', function () {
        if (flgChangeFocusSearchDepartment) {
            // 対象行の部門リストにフォーカス移動
            $('.input-department-select').focus();
            // フラグをOFF
            flgChangeFocusSearchDepartment = false;
        }
    });

    /**
     * 得意先コードキーダウンインイベント
     */
    $('.input-customer-code-copy-check').keydown(function (event) {
        let code = event.code;
        // スペース押下時、かつ未入力の場合
        if (code === 'Space' && $(this).val().length === 0) {
            // 得意先検索ボタンクリック
            $('[data-target="#search-customer-copy-check"]').click();
            return false;
        }
    });

    /**
     * 工事番号キーダウンインイベント
     */
    $('.input-constr-site-number-copy-check').keydown(function (event) {
        let code = event.code;
        // スペース押下時、かつ未入力の場合
        if (code === 'Space' && $(this).val().trim().length === 0) {
            // 工事番号検索ボタンクリック
            $('[data-target="#search-constr-site-copy-check"]').click();
            return false;
        }
    });

    /**
     * 担当者（社員）キーダウンインイベント
     */
    $('.input-employee-code-copy-check').keydown(function (event) {
        let code = event.code;
        // スペース押下時、かつ未入力の場合
        if (code === 'Space' && $(this).val().length === 0) {
            // 工事番号検索ボタンクリック
            $('[data-target="#search-employee-copy-check"]').click();
            return false;
        }
    });

    /**
     * 部門キーダウンインイベント
     */
    $('.input-department-code-copy-check').keydown(function (event) {
        let code = event.code;
        // スペース押下時、かつ未入力の場合
        if (code === 'Space' && $(this).val().length === 0) {
            // 部門検索ボタンクリック
            $('[data-target="#search-department-copy-check"]').click();
            return false;
        }
    });
})();

/**
 * チェックボックス変更時のイベント
 *
 * @param target
 */
window.changeInputTag = function (target) {
    $(target).parent().parent().find('.copy_input').prop('disabled', false);
    if ($(target).prop('checked')) {
        $(target).parent().parent().find('.copy_input').prop('disabled', true);
    }
}

/**
 * チェックボックス変更時のイベント
 *
 * @param id
 */
window.getCopyCheckArea = function (id) {
    axios.get($('.hidden-get-copy-check-url').val(), {
        params: {
            // 伝票のid
            id: id,
            // モデルのクラス名
            model: $('.hidden-get-order-model').val(),
            // 伝票の種類
            order: $('.hidden-get-order-name').val(),
        }
    }).then(response => {
        // 正常処理時
        // copy_check_areaの子要素を削除
        $('.copy_check_area').children().remove();
        // レスポンスデータ(HTML)をcopy_check_areaに追加
        $(response.data).appendTo('.copy_check_area');
        disabledCopyCheckArea();
        existsEstimateNumber($('.input-estimate-number-copy-check'));

        /**
         * 得意先と業者の変更処理
         */
        switchCustomerOrBusinessPartnerByLoad($('.input-switch-required-customer-or-business-partner').val());
    }).catch(error => {
        // エラー時
        console.error(error);
    });
}

/**
 * 得意先コード変更時の処理
 * @param target
 */
window.changeCustomerCodeCopyCheck = function (target) {
    let targetValue = $(target).val();

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    let targetOption = ".input-customer-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-customer-select-copy-check').prop('selectedIndex', 0);
    }

    // 得意先セレクトボックス変更処理
    changeCustomerCopyCheck();
    // 支払条件セット
    setPaymentTermsCopyCheck();
}

/**
 * 得意先変更処理
 */
window.changeCustomerCopyCheck = function () {
    let code = $('.input-customer-select-copy-check option:selected').data('code');
    // 選択された得意先名のコードをセット
    $('.input-customer-code-copy-check').val(code);

    // // 選択された得意先の税計算区分をセット
    // setTaxCalcType();
    // // 各合計値セット
    // setTotalAmounts();
    // 工事セレクトボックスフィルタリング
    filterConstrSiteCopyCheck();
    // 工事検索モーダルリストフィルタリング
    filterModalConstrSiteCopyCheck();

    // 連携機能の使用有無のラジオボタン表示非表示切り替え
    switchingWithConnectionAreaCopyCheck();
}

/**
 * 得意先セレクトボックス変更処理
 *
 * @param target
 */
window.changeCustomerSelectBox = function (target) {
    let targetOption = ".input-customer-select-copy-check option[data-code='" + parseInt($(target).find('option:selected').data('code')) + "']";
    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-customer-select-copy-check').prop('selectedIndex', 0);
    }
    changeCustomerCopyCheck();
}

/**
 * 得意先検索モーダル用 得意先選択
 * @param target
 */
window.selectCustomerSearchCustomerModalCopyCheck = function (target) {
    let targetValue = $(target).data('customer-code');

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    $('.input-customer-code').val(targetValue);

    let targetOption = ".input-customer-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-customer-select-copy-check').prop('selectedIndex', 0);
    }

    // 得意先セレクトボックス変更処理
    changeCustomerCopyCheck();
    // 支払条件セット
    setPaymentTermsCopyCheck();

    // 得意先検索モーダルを閉じる
    $('#search-customer-copy-check').modal('hide');

    // フォーカス移動ON
    flgChangeFocusSearchCustomer = true;
}

/**
 * 支払条件セット処理
 */
window.setPaymentTermsCopyCheck = function () {
    let targetCustomer = $('.input-customer-select-copy-check option:selected');
    $('.input-payment-terms').val("");
    if ((targetCustomer).val() !== '') {
        let collectionMonth = $(targetCustomer).data('collection-month') ?? "";
        let collectionDay = $(targetCustomer).data('collection-day') ?? "";
        if (collectionDay !== "") {
            collectionDay += '日';
        }
        let collectionMethod = $(targetCustomer).data('collection-method') ?? "";
        let paymentTerms = collectionMonth + collectionDay + collectionMethod;
        $('.input-payment-terms-copy-check').val(paymentTerms);
    }
}

/**
 * 発注先コード変更時の処理
 * @param target
 */
window.changeBizPartnerCodeCopyCheck = function (target) {
    let targetValue = $(target).val();

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    let targetOption = ".input-biz-partner-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-biz-partner-select-copy-check').prop('selectedIndex', 0);
    }

    // 発注先セレクトボックス変更処理
    changeBizPartnerCopyCheck();
}

/**
 * 発注先変更処理
 */
window.changeBizPartnerCopyCheck = function () {
    let code = $('.input-biz-partner-select-copy-check option:selected').data('code');

    // 選択された発注先のコードをセット
    $('.input-biz-partner-code-copy-check').val(code);

    // 連携機能の使用有無のラジオボタン表示非表示切り替え
    switchingWithConnectionAreaCopyCheck('biz-partner');
}

/**
 * 発注先セレクトボックス変更処理
 */
window.changeBizPartnerSelectBox = function (target) {
    let targetOption = ".input-biz-partner-select-copy-check option[data-code='" + parseInt($(target).find('option:selected').data('code')) + "']";
    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-customer-select-copy-check').prop('selectedIndex', 0);
    }
    changeBizPartnerCopyCheck();
}

/**
 * 発注先検索モーダル用 業者選択
 * @param target
 */
window.selectBizPartnerSearchBizPartnerModalCopyCheck = function (target) {
    let targetValue = $(target).data('biz-partner-code-copy-check');

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    $('.input-biz-partner-code-copy-check').val(targetValue);

    let targetOption = ".input-biz-partner-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-biz-partner-select-copy-check').prop('selectedIndex', 0);
    }

    // 発注先セレクトボックス変更処理
    changeBizPartnerCopyCheck();

    // 発注先検索モーダルを閉じる
    $('#search-biz-partner-copy-check').modal('hide');

    // フォーカス移動ON
    flgChangeFocusSearchBizPartner = true;
}

/**
 * 得意先と業者の変更処理
 */
window.switchCustomerOrBusinessPartner = function (target) {
    let class_customer = 'switching-customer';
    let class_biz_partner = 'switching-biz-partner';
    let switch_required = 'input-switch-required-customer-or-business-partner';
    let customer = $('.' + class_customer);
    let biz_partner = $('.' + class_biz_partner)

    if ($(target).parent().hasClass(class_customer)) {
        customer.parent().find('.' + class_customer).css('cssText', 'display:none !important');
        biz_partner.css('display', '');
        $('.' + switch_required).val('biz_partner');
        customer.parent().find('.' + class_customer).removeClass('is-required');
        biz_partner.addClass('is-required');
    }
    if ($(target).parent().hasClass(class_biz_partner)) {
        customer.css('display', '');
        biz_partner.parent().find('.' + class_biz_partner).css('cssText', 'display:none !important');
        $('.' + switch_required).val('customer');
        customer.addClass('is-required');
        biz_partner.parent().find('.' + class_biz_partner).removeClass('is-required');
    }

    $('.input-customer-select').prop('selectedIndex', 0);
    $('.input-biz-partner-select').prop('selectedIndex', 0);
    changeCustomerCopyCheck();
    setPaymentTermsCopyCheck();
    changeBizPartnerCopyCheck();
    checkAllRequiredFieldsCopyCheck();
}

/**
 * 得意先と業者の変更処理(ロードイベント時)
 */
window.switchCustomerOrBusinessPartnerByLoad = function (required_name) {
    let class_customer = 'switching-customer';
    let class_biz_partner = 'switching-biz-partner';
    let switch_required = 'input-switch-required-customer-or-business-partner';

    if (required_name === 'biz_partner') {
        $('.' + class_customer).parent().find('.' + class_customer).css('cssText', 'display:none !important');
        $('.' + class_biz_partner).css('display', '');
        $('.' + switch_required).val('biz_partner');
    }
    if (required_name === 'customer') {
        $('.' + class_customer).css('display', '');
        $('.' + class_biz_partner).parent().find('.' + class_biz_partner).css('cssText', 'display:none !important');
        $('.' + switch_required).val('customer');
    }
}

/**
 * 工事セレクトボックスフィルタリング処理
 */
window.filterConstrSiteCopyCheck = function () {
    // 全体を一旦クリア
    $(".input-constr-site-select-copy-check option").removeClass('d-none');

    let targetCustomerId = $('.input-customer-select-copy-check option:selected').val();
    if (targetCustomerId !== '') {
        $(".input-constr-site-select-copy-check option").each(function () {
            if ($(this).data('customer-id') === undefined) {
                return true;
            }
            if ($(this).data('customer-id') !== parseInt(targetCustomerId)) {
                // 得意先IDが不一致は非表示セット
                $(this).addClass('d-none');
            }
            if ($(this).data('complete') === 1) {
                if ($('.input-constr-site-number-copy-check').val() !== $(this).data('number')) {
                    // 完成している工事は不一致は非表示セット
                    $(this).addClass('d-none');
                }
            }
        });
    }

    let selectIndex = $('.input-constr-site-select-copy-check').prop('selectedIndex');
    // 選択状態でない、または選択状態が非表示の場合
    if (selectIndex === -1 || $('.input-constr-site-select-copy-check :selected').hasClass('d-none')) {
        // 非表示でない最初の項目インデックス取得
        let firstIndex = $('.input-constr-site-select-copy-check option').not('.d-none').first().index();
        // 対象項目を選択状態にする
        $('.input-constr-site-select-copy-check').prop('selectedIndex', firstIndex);
        // 工事セレクトボックス変更処理
        changeConstructionSiteCopyCheck();
    }
}

/**
 * 工事検索モーダルリストフィルタリング処理
 */
window.filterModalConstrSiteCopyCheck = function () {
    let targetCustomerId = $('.input-customer-select-copy-check option:selected').val();
    $("#constr_sites_table tbody tr").each(function () {
        let txtConstrSiteCustomerId = $(this).closest('tr').children('td')[2].innerText;
        if (!targetCustomerId || txtConstrSiteCustomerId === targetCustomerId) {
            $(this).show();
            $(this).removeClass('inactive');
        } else {
            $(this).hide();
            $(this).addClass('inactive');
        }
    });
    // 工事テーブル行にCSS追加 ※背景色はcommon に合わせること。
    $("#constr_sites_table tr:not(.inactive):even td").css("background-color", "#afeeee");
    $("#constr_sites_table tr:not(.inactive):odd td").css("background-color", "#fff");
}

/**
 * 工番コード変更時の処理
 * @param target
 */
window.changeConstructionSiteNumber = function (target) {
    let targetValue = $(target).val();
    let targetOption = ".input-constr-site-select-copy-check option[data-number='" + targetValue + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-constr-site-select-copy-check').prop('selectedIndex', 0);
    }

    // 工番セレクトボックス変更処理
    changeConstructionSiteCopyCheck();
}

/**
 * 工番セレクトボックス変更処理
 */
window.changeConstructionSiteCopyCheck = function () {
    let number = $('.input-constr-site-select-copy-check option:selected').data('number');
    // 選択された工事番号をセット
    $('.input-constr-site-number-copy-check').val(number);

    let contractAmount = $('.input-constr-site-select-copy-check option:selected').data('contract-amount');
    let orderTotal = $('.input-constr-site-select-copy-check option:selected').data('order-total');
    let grossProfit = 0;    // 差額

    if (contractAmount !== undefined) {
        grossProfit = Number(contractAmount);
        contractAmount = Number(contractAmount).toLocaleString();
    } else {
        contractAmount = '{{ $mark_blank }}';
    }

    if (orderTotal !== undefined) {
        grossProfit = grossProfit - Number(orderTotal);
        orderTotal = Number(orderTotal).toLocaleString();
    } else {
        orderTotal = '{{ $mark_blank }}';
    }

    if (contractAmount === '{{ $mark_blank }}' || orderTotal === '{{ $mark_blank }}') {
        grossProfit = '{{ $mark_blank }}';
    } else {
        grossProfit = grossProfit.toLocaleString();
    }

    // 選択された金額をセット
    $('.text-contract-amount').text(contractAmount);
    $('.text-order-total').text(orderTotal);
    $('.text-gross-profit').text(grossProfit);
}

/**
 * 工番検索モーダル用 工番選択
 * @param target
 */
window.selectConstrSiteSearchConstrSiteModalCopyCheck = function (target) {
    let targetValue = $(target).data('constr-site-id');

    let targetNumber = $(target).data('constr-site-number');
    targetNumber = targetNumber === 'コードなし' ? '' : targetNumber;

    $('.input-constr-site-number').val(targetNumber);

    let targetOption = ".input-constr-site-select-copy-check option[value='" + targetValue + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-constr-site-select-copy-check').prop('selectedIndex', 0);
    }

    // 工番セレクトボックス変更処理
    changeConstructionSiteCopyCheck();

    // 工番検索モーダルを閉じる
    $('#search-constr-site-copy-check').modal('hide');

    // フォーカス移動ON
    flgChangeFocusSearchConstrSite = true;
}

/**
 * 担当者コード変更時の処理
 * @param target
 */
window.changeEmployeeCodeCopyCheck = function (target) {
    let targetValue = $(target).val();

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    let targetOption = ".input-employee-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-employee-select-copy-check').prop('selectedIndex', 0);
    }

    $('#employee_id_').val(targetValue);

    // 部門セット
    setDepartmentCopyCheck();
}

/**
 * 担当者変更処理
 */
window.changeEmployeeCopyCheck = function () {
    let select = $('.input-employee-select-copy-check option:selected');
    // 選択された担当者のコードをセット
    $('.input-employee-code-copy-check').val(select.data('code'));

    // 選択されたコードの担当者名をセット
    $("input[name='employee_name']").val(select.data('employee-name'));

    $('#employee_id_').val(select.data('code'));

    // 部門セット
    setDepartmentCopyCheck();
}

/**
 * 担当者セレクトボックス変更処理
 */
window.changeEmployeeSelectBox = function (target) {
    let targetOption = ".input-employee-select-copy-check option[data-code='" + parseInt($(target).find('option:selected').data('code')) + "']";
    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-employee-select-copy-check').prop('selectedIndex', 0);
    }

    changeEmployeeCopyCheck();
}

/**
 * 担当者検索モーダル用 担当者選択
 * @param target
 */
window.selectEmployeeSearchEmployeeModalCopyCheck = function (target) {
    let targetValue = $(target).data('employee-code');

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    $('.input-employee-code').val(targetValue);

    let targetOption = ".input-employee-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-employee-select-copy-check').prop('selectedIndex', 0);
    }

    // 担当者検索モーダルを閉じる
    $('#search-employee-copy-check').modal('hide');

    $('#employee_id_').val(targetValue);

    changeEmployeeCopyCheck();

    // フォーカス移動ON
    flgChangeFocusSearchEmployee = true;
}

/**
 *  部門セット
 */
window.setDepartmentCopyCheck = function () {
    let code = $('.input-employee-select-copy-check option:selected').data('department-code');
    if (code === "") {
        return;
    }
    let target = $('.input-department-code-copy-check');
    $(target).val(code);
    changeDepartmentCodeCopyCheck($(target));
}

/**
 * 部門コード変更時の処理
 * @param target
 */
window.changeDepartmentCodeCopyCheck = function (target) {
    let targetValue = $(target).val();

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    let targetOption = ".input-department-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-department-select-copy-check').prop('selectedIndex', 0);
    }
}

/**
 * 部門変更処理
 */
window.changeDepartmentCopyCheck = function () {
    let code = $('.input-department-select-copy-check option:selected').data('code');
    // 選択された担当者のコードをセット
    $('.input-department-code-copy-check').val(code);
}

/**
 * 部門セレクトボックス変更処理
 *
 * @param target
 */
window.changeDepartmentSelectBox = function (target) {
    let targetOption = ".input-department-select-copy-check option[data-code='" + parseInt($(target).find('option:selected').data('code')) + "']";
    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-department-select-copy-check').prop('selectedIndex', 0);
    }

    changeDepartmentCopyCheck();
}

/**
 * 部門検索モーダル用 部門選択
 * @param target
 */
window.selectDepartmentSearchDepartmentModalCopyCheck = function (target) {
    let targetValue = $(target).data('department-code');

    if (isNaN(targetValue)) {
        targetValue = -1;
    }

    $('.input-department-code').val(targetValue);

    let targetOption = ".input-department-select-copy-check option[data-code='" + parseInt(targetValue) + "']";

    if ($(targetOption).not('.d-none').length) {
        // 対象コードがあれば、そのリストを選択状態にする
        $(targetOption).prop('selected', true);
    } else {
        // 対象コードがなければ、最初のリストを選択状態にする
        $('.input-department-select-copy-check').prop('selectedIndex', 0);
    }

    // 部門検索モーダルを閉じる
    $('#search-department-copy-check').modal('hide');

    changeDepartmentCopyCheck();

    // フォーカス移動ON
    flgChangeFocusSearchDepartment = true;
}

/**
 * 連携機能使用有無のラジオボタンのエリアを表示非表示
 * @param select string
 */
window.switchingWithConnectionAreaCopyCheck = function (select = 'customer') {
    let with_connection_area = $('.with_connection_area');
    if (!$('.input-' + select + '-select-copy-check option:selected').data('has-connection')) {
        // 連携機能を使用しないにチェック
        $('#with_connection_0').prop('checked', true);
        with_connection_area.hide();
        with_connection_area.prop('disabled', true);

        return false;
    }
    // 連携機能を使用するにチェック
    $('#with_connection_1').prop('checked', true);
    with_connection_area.show();
    with_connection_area.prop('disabled', false);
}

/**
 * 見積番号変更時のイベント
 *
 * @param target
 */
window.existsEstimateNumber = function (target) {
    let ok_button = $('#btn_ok_confirm-copy');
    if (!$(target).val()) {
        // 複製確認モーダルのOKボタンをenabled
        ok_button.prop('disabled', false);
        return false;
    }

    axios.get($('.hidden-exists-estimate-number-url').val(), {
        params: {
            // 見積番号
            estimate_number: $(target).val(),
        }
    }).then(response => {
        // 正常処理時
        let estimate_number = $('.input-estimate-number-copy-check');

        // 初期化
        estimate_number.removeClass('is-invalid');
        ok_button.prop('disabled', false);

        if (!response.data['exists']) {
            $('.exists-estimate-number-message').remove();
            return false;
        }
        // 見積番号が存在していた時の処理
        estimate_number.addClass('is-invalid');
        $(response.data['err_msg']).appendTo('.estimate-number-area');
        ok_button.prop('disabled', true);
    }).catch(error => {
        // エラー時
        console.error(error);
    });
};
